import { render, staticRenderFns } from "./StreamComponent.vue?vue&type=template&id=3c65f475&"
import script from "./StreamComponent.vue?vue&type=script&lang=js&"
export * from "./StreamComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports